// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  muted country boundaries */
.em--flow .em-cntbn {
    stroke: grey;
    stroke-width: 0.25px;
}

/* dim everything except the highlighted color group */
.em-flow-container line.dimmed,
.em-flow-lines line.dimmed,
.em-flow-container path.em-flow-link.dimmed,
.em-flow-lines path.em-flow-link.dimmed {
    opacity: 0;
}

/* emphasize the matching ones */
.em-flow-container line.highlighted,
.em-flow-lines line.highlighted {
    opacity: 1;
}

.em-flow-container path.em-flow-link.highlighted,
.em-flow-lines path.em-flow-link.highlighted {
    /* tapered polygons use FILL */
    filter: brightness(1.05);
    opacity: 1;
}

.em-legend-label.em-flow-legend-min-label,
.em-legend-label.em-flow-legend-max-label {
    font-size: 12px;
    fill: #666;
}

/* DONUT TOOLTIP */
.em-donut-tooltip-table {
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: fixed; /* required for ellipsis to work predictably */
}

.em-donut-tooltip-table td {
    padding: 3px 0;
    font-size: 12px;
    vertical-align: middle;
}

.em-donut-tooltip-table td:last-child {
    width: 32%;
    text-align: right;
    white-space: nowrap;
}

.em-donut-tooltip-table {
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    border-spacing: 0;
    box-sizing: border-box;
}

.em-donut-tooltip-table td {
    padding: 2px 6px;
    font-size: 12px;
    vertical-align: middle;
    box-sizing: border-box;
}

.em-donut-tooltip-table td:last-child {
    text-align: right;
    white-space: nowrap;
    padding-left: 6px;
}

.em-donut-tooltip-table td:first-child {
    padding-right: 6px;
    box-sizing: border-box;
    min-width: 0;
}

.em-donut-tooltip-label {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
}

.em-donut-tooltip-colorchip {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
}

.em-tooltip-label-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
    min-width: 0;
    display: inline-block;
    vertical-align: middle;
}

.em-donut-tooltip-section-header td {
    padding-top: 6px;
    font-weight: 600;
    color: #222;
}
.em-donut-tooltip-row td {
    padding-top: 2px;
}
.em-donut-tooltip-total td {
    padding-top: 6px;
    font-weight: 700;
    border-top: 1px solid #ddd;
}

.em-tooltip-text {
    max-width: 320px;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0;
}

/* END DONUT TOOLTIP */
`, "",{"version":3,"sources":["webpack://./src/css/layers/flow.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,sDAAsD;AACtD;;;;IAII,UAAU;AACd;;AAEA,gCAAgC;AAChC;;IAEI,UAAU;AACd;;AAEA;;IAEI,8BAA8B;IAC9B,wBAAwB;IACxB,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB,EAAE,8CAA8C;AACvE;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA,sBAAsB","sourcesContent":["/*  muted country boundaries */\r\n.em--flow .em-cntbn {\r\n    stroke: grey;\r\n    stroke-width: 0.25px;\r\n}\r\n\r\n/* dim everything except the highlighted color group */\r\n.em-flow-container line.dimmed,\r\n.em-flow-lines line.dimmed,\r\n.em-flow-container path.em-flow-link.dimmed,\r\n.em-flow-lines path.em-flow-link.dimmed {\r\n    opacity: 0;\r\n}\r\n\r\n/* emphasize the matching ones */\r\n.em-flow-container line.highlighted,\r\n.em-flow-lines line.highlighted {\r\n    opacity: 1;\r\n}\r\n\r\n.em-flow-container path.em-flow-link.highlighted,\r\n.em-flow-lines path.em-flow-link.highlighted {\r\n    /* tapered polygons use FILL */\r\n    filter: brightness(1.05);\r\n    opacity: 1;\r\n}\r\n\r\n.em-legend-label.em-flow-legend-min-label,\r\n.em-legend-label.em-flow-legend-max-label {\r\n    font-size: 12px;\r\n    fill: #666;\r\n}\r\n\r\n/* DONUT TOOLTIP */\r\n.em-donut-tooltip-table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    table-layout: fixed; /* required for ellipsis to work predictably */\r\n}\r\n\r\n.em-donut-tooltip-table td {\r\n    padding: 3px 0;\r\n    font-size: 12px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.em-donut-tooltip-table td:last-child {\r\n    width: 32%;\r\n    text-align: right;\r\n    white-space: nowrap;\r\n}\r\n\r\n.em-donut-tooltip-table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    table-layout: fixed;\r\n    border-spacing: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.em-donut-tooltip-table td {\r\n    padding: 2px 6px;\r\n    font-size: 12px;\r\n    vertical-align: middle;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.em-donut-tooltip-table td:last-child {\r\n    text-align: right;\r\n    white-space: nowrap;\r\n    padding-left: 6px;\r\n}\r\n\r\n.em-donut-tooltip-table td:first-child {\r\n    padding-right: 6px;\r\n    box-sizing: border-box;\r\n    min-width: 0;\r\n}\r\n\r\n.em-donut-tooltip-label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n}\r\n\r\n.em-donut-tooltip-colorchip {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.em-tooltip-label-text {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n.em-donut-tooltip-section-header td {\r\n    padding-top: 6px;\r\n    font-weight: 600;\r\n    color: #222;\r\n}\r\n.em-donut-tooltip-row td {\r\n    padding-top: 2px;\r\n}\r\n.em-donut-tooltip-total td {\r\n    padding-top: 6px;\r\n    font-weight: 700;\r\n    border-top: 1px solid #ddd;\r\n}\r\n\r\n.em-tooltip-text {\r\n    max-width: 320px;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    padding: 0;\r\n}\r\n\r\n/* END DONUT TOOLTIP */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
